// Resolves only when the server confirms with { ok: true }; anything else throws.
export async function postSignup(list: 'waitlist' | 'beta', email: string, website: string, source = '') {
  const controller = new AbortController()
  const timeout = window.setTimeout(() => controller.abort(), 12000)
  try {
    const response = await fetch('/api/waitlist', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, website, list, source }), signal: controller.signal,
    })
    const data: unknown = await response.json().catch(() => null)
    // A 200 HTML fallback or an empty response must never count as a signup.
    if (!response.ok || !data || typeof data !== 'object' || !('ok' in data) || data.ok !== true) {
      throw new Error('Signup not confirmed')
    }
  } finally {
    window.clearTimeout(timeout)
  }
}
